// extracted by mini-css-extract-plugin
export default {"container":"Marker_container__yGuRT","name":"Marker_name__D-MdD","marker":"Marker_marker__+1ELB","label":"Marker_label__9G-HC"};